// @flow
import { push } from 'react-router-redux';
import { fetchMe } from './user.actions';

const GTM_ACCOUNTS_URL = '/api/projects/:id/gtm/accounts';
const GTM_CONTAINERS_URL = '/api/projects/:id/gtm/accounts/:accountId/containers';
const GTM_WORKSPACES_URL =
  '/api/projects/:id/gtm/accounts/:accountId/containers/:containerId/workspaces';

const UA_CODES_URL =
  '/api/projects/:id/gtm/accounts/:accountId/containers/:containerId/uaVariables';

export const UA_CODES_UPDATED = 'uacodes/UPDATED';
export const UA_CODES_UPDATING = 'uacodes/UPDATING';
export const UA_CODES_FETCH_ERROR = 'uacodes/ERROR';

export const GTM_ACCOUNTS_UPDATED = 'gtm_accounts/UPDATED';
export const GTM_ACCOUNTS_UPDATING = 'gtm_accounts/UPDATING';
export const GTM_ACCOUNTS_FETCH_ERROR = 'gtm_accounts/ERROR';

export const CONTAINERS_UPDATED = 'containers/UPDATED';
export const CONTAINERS_UPDATING = 'containers/UPDATING';
export const CONTAINERS_FETCH_ERROR = 'containers/ERROR';

export const WORKSPACES_UPDATED = 'workspaces/UPDATED';
export const WORKSPACES_UPDATING = 'workspaces/UPDATING';
export const WORKSPACES_FETCH_ERROR = 'workspaces/ERROR';

export const getGtmAccounts = ({ id }: { id: string }) => {
  const fetchUrl = GTM_ACCOUNTS_URL.replace(':id', `${id}`);
  return (dispatch: Function) => {
    dispatch({ type: GTM_ACCOUNTS_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: GTM_ACCOUNTS_FETCH_ERROR, data });
        }
        dispatch({
          type: GTM_ACCOUNTS_UPDATED,
          data
        });
      });
  };
};

export const getContainers = ({ id, accountId }: { id: string, accountId: string }) => {
  const fetchUrl = GTM_CONTAINERS_URL.replace(':id', `${id}`).replace(':accountId', `${accountId}`);
  return (dispatch: Function) => {
    dispatch({ type: CONTAINERS_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: CONTAINERS_FETCH_ERROR, data });
        }
        dispatch({
          type: CONTAINERS_UPDATED,
          data
        });
      });
  };
};

export const getWorkspaces = ({
  id,
  accountId,
  containerId
}: {
  id: string,
  accountId: string,
  containerId: string
}) => {
  const fetchUrl = GTM_WORKSPACES_URL.replace(':id', `${id}`)
    .replace(':accountId', `${accountId}`)
    .replace(':containerId', `${containerId}`);
  return (dispatch: Function) => {
    dispatch({ type: WORKSPACES_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: WORKSPACES_FETCH_ERROR, data });
        }
        dispatch({
          type: WORKSPACES_UPDATED,
          data
        });
      });
  };
};
export const getUaVariables = ({
  id,
  accountId,
  containerId
}: {
  id: string,
  accountId: string,
  containerId: string
}) => {
  const fetchUrl = UA_CODES_URL.replace(':id', `${id}`)
    .replace(':accountId', `${accountId}`)
    .replace(':containerId', `${containerId}`);
  return (dispatch: Function) => {
    dispatch({ type: UA_CODES_UPDATING });
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        if (status === 403) {
          return dispatch({ type: UA_CODES_FETCH_ERROR, data });
        }
        dispatch({
          type: UA_CODES_UPDATED,
          data
        });
      });
  };
};

export default {
  getGtmAccounts,
  getContainers,
  getWorkspaces,
  getUaVariables
};



// WEBPACK FOOTER //
// ./src/actions/gtmapi.actions.js